<template>
  <div id="app">
    <NavBar v-show="showNavBar"></NavBar>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import NavBar from "@/components/NavBar";

export default {
  name: "App",
  components: {NavBar},
  methods: {
    ...mapMutations("user", ["isAdmin"])
  },
  computed: {
    showNavBar() {
      let notShow = ["Login", undefined];
      return notShow.indexOf(this.$route.name) === -1;
    },
    loginRequired() {
      return !this.$store.state.user.isLogin;
    }
  },
  watch: {
    loginRequired: {
      handler(newValue) {
        if (newValue) {
          this.$router.push("/login");
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
